/* chat-extras.js | Brainzyme Chat | v12 - Final Optimised */

(function() {
  const CHAT_WIDGET_TAG = 'n8nchatui-popup';
  const STYLE_ID = 'brainzyme-chat-style-override';

  function applySizeFix() {
    try {
      const popupElement = document.querySelector(CHAT_WIDGET_TAG);
      if (!popupElement?.shadowRoot) return;

      let styleElement = popupElement.shadowRoot.getElementById(STYLE_ID);
      if (!styleElement) {
        styleElement = document.createElement('style');
        styleElement.id = STYLE_ID;
        popupElement.shadowRoot.appendChild(styleElement);
      }

      let newCssRules = '';

      if (window.innerWidth <= 640) {
        // --- MOBILE CSS RULES ---
        const mobileHeight = window.innerHeight * 0.6;
        newCssRules = `
          div[part="bot"] {
            height: ${mobileHeight}px !important;
            max-height: ${mobileHeight}px !important;
            width: 100vw !important;
            bottom: 0px !important;
            right: 0px !important;
            top: auto !important;
            border-radius: 0px !important;
          }
        `;
      } else {
        // --- DESKTOP CSS RULES ---
        const bottomMargin = 120;
        const desktopMaxHeight = window.innerHeight - bottomMargin;
        newCssRules = `
          div[part="bot"] {
            width: 400px !important;
            height: 600px !important;
            max-height: ${desktopMaxHeight}px !important;
            top: auto !important;
            right: 20px !important;
            bottom: 95px !important;
            border-radius: 10px !important;
          }
        `;
      }
      
      if (styleElement.innerText !== newCssRules) {
        styleElement.innerText = newCssRules;
      }

    } catch (e) {
      // Errors are silent in production
    }
  }

  function initializeStyleController() {
    const popupElement = document.querySelector(CHAT_WIDGET_TAG);
    if (!popupElement) return;

    // A one-time setup for open and resize events
    popupElement.addEventListener('openBot', applySizeFix);
    window.addEventListener('resize', applySizeFix);
    
    // Also run once in case the bot is already open on load
    setTimeout(applySizeFix, 500); 
  }

  function waitForChatWidget() {
    let attempts = 0;
    const interval = setInterval(() => {
      const chatWidgetElement = document.querySelector(CHAT_WIDGET_TAG);
      
      if (chatWidgetElement && chatWidgetElement.shadowRoot) {
        clearInterval(interval);
        initializeStyleController();
      } else if (attempts++ > 75) {
        clearInterval(interval);
      }
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForChatWidget);
  } else {
    waitForChatWidget();
  }

})();